import constants, { WORKSPACE_RIGHT_PANEL_NAMES } from '#packages/constants';
import { userPreferences } from '#packages/stateManagement';
import { site as siteUserPreferences } from '../userPreferences/userPreferences';
import { WorkspaceRightPanelApiKey } from '#packages/apis';
import type { EditorAPI } from '#packages/editorAPI';

const EDITOR_APP_ID = 'editorAppId';

const { ADVANCED_SETTINGS } = constants.USER_PREFS.ACCESSIBILITY;

export function setAdvancedSettings(
  editorAPI: EditorAPI,
  appData: AnyFixMe,
  token: AnyFixMe,
  { value = false },
) {
  const areSitePrefsLoaded = userPreferences.selectors.getSitePrefFetchStatus(
    editorAPI.store.getState(),
  );
  if (!areSitePrefsLoaded) {
    return Promise.reject(new Error('Site preferences are not loaded'));
  }
  return siteUserPreferences.set(
    editorAPI,
    { appDefinitionId: EDITOR_APP_ID },
    token,
    {
      [ADVANCED_SETTINGS]: value,
    },
  );
}

export function getAdvancedSettings(
  editorAPI: AnyFixMe,
  appData: AnyFixMe,
  token: AnyFixMe,
) {
  const areSitePrefsLoaded = userPreferences.selectors.getSitePrefFetchStatus(
    editorAPI.store.getState(),
  );
  if (!areSitePrefsLoaded) {
    return Promise.reject(new Error('Site preferences are not loaded'));
  }
  return siteUserPreferences
    .get(editorAPI, { appDefinitionId: EDITOR_APP_ID }, token, [
      ADVANCED_SETTINGS,
    ])
    .then((results) => (results as AnyFixMe)[ADVANCED_SETTINGS]);
}

export const openAccessibilityWizard = async (editorAPI: EditorAPI) => {
  const workspaceRightPanelApi = editorAPI.host.getAPI(
    WorkspaceRightPanelApiKey,
  );

  workspaceRightPanelApi.open('a11yWizard', {
    panelName: WORKSPACE_RIGHT_PANEL_NAMES.A11Y_WIZARD,
    panelWidth: 306,
    title: '',
    renderHeader: false,
    enterZoomMode: false,
    leavePanelOpen: true,
  });
};
